export default __webpack_public_path__ + "static/media/tokonomics.a4ab2ca1.svg";